import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

const AdminLayout = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <div className="brand-lockup">
            <span className="brand-mark"><i className="fas fa-wave-square"></i></span>
            <div>
              <h2>AudioCore</h2>
              <span className="brand-kicker">Broadcast desk</span>
            </div>
          </div>
          <p className="user-info">
            <i className="fas fa-user"></i> {user?.username}
          </p>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/admin" end className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-home"></i>
            <span>Dashboard</span>
          </NavLink>
          
          <NavLink to="/admin/tracks" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-list"></i>
            <span>Tracks</span>
          </NavLink>
          
          <NavLink to="/admin/upload" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-upload"></i>
            <span>Upload</span>
          </NavLink>
          
          <NavLink to="/admin/tts" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-microphone"></i>
            <span>TTS Queue</span>
          </NavLink>
          
          <NavLink to="/admin/announcements" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-robot"></i>
            <span>AI Announcements</span>
          </NavLink>
          
          <NavLink to="/admin/scheduler" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-calendar-alt"></i>
            <span>Weekkalender</span>
          </NavLink>
          
          <NavLink to="/admin/news" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-newspaper"></i>
            <span>Nieuws</span>
          </NavLink>
          
          <NavLink to="/admin/weather" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-cloud-sun"></i>
            <span>Weer</span>
          </NavLink>
          
          <NavLink to="/admin/music-prompt" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-magic"></i>
            <span>Muziek Prompt</span>
          </NavLink>
          
          <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-users"></i>
            <span>Users</span>
          </NavLink>
          
          <NavLink to="/admin/settings" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <i className="fas fa-cog"></i>
            <span>Settings</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
